import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await authService.logout();
        navigate('/auth/login');
      } catch (error) {
        console.error('Logout error:', error);
        navigate('/auth/login');
      }
    };

    performLogout();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-2xl shadow-lg p-8 text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">Logging out...</h2>
        <p className="text-slate-500 dark:text-slate-400">Please wait while we sign you out.</p>
      </div>
    </div>
  );
};

export default Logout; 